import {
    ChangeDetectorRef,
    Component,
    OnInit,
    inject,
  } from '@angular/core';
  import { CommonModule } from '@angular/common';
  import { FormsModule } from '@angular/forms';
  import {
    FormBuilder,
    FormGroup,
    Validators,
    ReactiveFormsModule,
  } from '@angular/forms';
  
  import { QuickActivityService } from '../../services/quick-activity.service';
  import { QuickActivity } from '../../interfaces/quick-activity.interfaces';
  import { ActivityService } from '../../services/activity.service';
  import { PaginationComponent } from '../ui/pagination/pagination.component';
  
  @Component({
    selector: 'app-quick-activities',
    standalone: true,
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        PaginationComponent,
      ],
    templateUrl: './quick-activities.html',
    styleUrl: './quick-activities.scss',
  })
  export class QuickActivitiesComponent implements OnInit {
    private quickActivityService = inject(QuickActivityService);
    private apiService = inject(ActivityService);
    private fb = inject(FormBuilder);
    private cdr = inject(ChangeDetectorRef);
  
    quickActivities: QuickActivity[] = [];
    page = 1;
    pageSize = 6;

    get pagedQuickActivities(): QuickActivity[] {
      const start = (this.page - 1) * this.pageSize;
      return this.quickActivities.slice(start, start + this.pageSize);
    }
  
    isLoading = true;
    errorMessage = '';
  
    showCreateForm = false;
    isSaving = false;
    successMessage = '';
    activityForm: FormGroup;
    activityTypes = ['mandatory', 'optional', 'specific'];

    showActivitySuccessMessage = false;
    isCreatingActivity = false;
    hasParticipantLimit = false;
  
    editingQuickActivityId: string | null = null;
    showDeleteModal = false;
    activityToDelete: QuickActivity | null = null;
    showPublishForm = false;
    activityToPublish: QuickActivity | null = null;

    publishForm = {
        startDate: '',
        dueDate: '',
        startTime: '',
        endTime: '',
        maxParticipants: null as number | null,
        comments: '',
      };
  
    newQuickActivity = {
      title: '',
      description: '',
      type: 'optional',
      valueInHours: 0,
      startTime: '',
      endTime: '',
      maxParticipants: null as number | null,
      comments: '',
    };

    constructor() {
        this.activityForm = this.fb.group({
          title: ['', Validators.required],
          description: [''],
          type: ['', Validators.required],
          startDate: [new Date()],
          dueDate: [''],
          startTime: ['', Validators.required],
          endTime: ['', Validators.required],
          valueInHours: [0, [Validators.required, Validators.min(0)]],
          comments: [''],
          maxParticipants: [null],
        });
      }
    onParticipantLimitChange(): void {
        if (this.hasParticipantLimit) {
          this.activityForm
            .get('maxParticipants')
            ?.setValidators([
              Validators.required,
              Validators.min(1),
              Validators.pattern(/^[0-9]+$/),
            ]);
        } else {
          this.activityForm.get('maxParticipants')?.clearValidators();
          this.activityForm.get('maxParticipants')?.setValue(null);
        }
      
        this.activityForm.get('maxParticipants')?.updateValueAndValidity();
    }

    createActivityFromForm(): void {
        console.log(
          'FORMULARIO ACTIVIDAD:',
          this.activityForm.value,
        );
      
        console.log(
          'FORMULARIO VÁLIDO:',
          this.activityForm.valid,
        );
      
        if (!this.activityForm.valid) {
          this.activityForm.markAllAsTouched();
          return;
        }
      
        this.newQuickActivity = {
          title: this.activityForm.value.title,
          description: this.activityForm.value.description,
          type: this.activityForm.value.type,
          valueInHours: this.activityForm.value.valueInHours,
          startTime: this.activityForm.value.startTime,
          endTime: this.activityForm.value.endTime,
          maxParticipants: this.activityForm.value.maxParticipants,
          comments: this.activityForm.value.comments,
        };
      
        this.saveQuickActivity();
      }
  
    ngOnInit(): void {
      this.loadQuickActivities();
    }
  
    private loadQuickActivities(): void {
      this.isLoading = true;
      this.errorMessage = '';
  
      this.quickActivityService.getAllQuickActivities().subscribe({
        next: (quickActivities) => {
          this.quickActivities = quickActivities;
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
  
        error: (error: unknown) => {
          console.error(
            'ERROR CARGANDO ACTIVIDADES RÁPIDAS:',
            error,
          );
  
          this.errorMessage =
            'No se pudieron cargar las actividades rápidas.';
  
          this.isLoading = false;
  
          this.cdr.detectChanges();
        },
      });
    }
  
    openCreateForm(): void {
        this.successMessage = '';
        this.errorMessage = '';
      
        this.showPublishForm = false;
        this.activityToPublish = null;
      
        this.editingQuickActivityId = null;
      
        this.activityForm.reset({
          title: '',
          description: '',
          type: '',
          startDate: new Date(),
          dueDate: '',
          startTime: '',
          endTime: '',
          valueInHours: 0,
          comments: '',
          maxParticipants: null,
        });
      
        this.hasParticipantLimit = false;
        this.showActivitySuccessMessage = false;
      
        this.showCreateForm = true;
      }
  
      openEditForm(activity: QuickActivity): void {
        this.successMessage = '';
        this.errorMessage = '';
      
        this.editingQuickActivityId = activity.id;
      
        this.newQuickActivity = {
          title: activity.title,
          description: activity.description,
          type: activity.type,
          valueInHours: activity.valueInHours,
          startTime: activity.startTime,
          endTime: activity.endTime,
          maxParticipants: activity.maxParticipants,
          comments: activity.comments,
        };
      
        this.activityForm.patchValue({
          title: activity.title,
          description: activity.description,
          type: activity.type,
          startTime: activity.startTime,
          endTime: activity.endTime,
          valueInHours: activity.valueInHours,
          comments: activity.comments,
          maxParticipants: activity.maxParticipants,
        });
      
        this.hasParticipantLimit = activity.maxParticipants != null;
      
        this.onParticipantLimitChange();
      
        this.showCreateForm = true;
      
        this.cdr.detectChanges();
      }
  
    closeCreateForm(): void {
      if (this.isSaving) {
        return;
      }
  
      this.showCreateForm = false;
      this.editingQuickActivityId = null;
      this.resetForm();
    }
  
    saveQuickActivity(): void {
      if (
        !this.newQuickActivity.title.trim() ||
        this.newQuickActivity.valueInHours <= 0
      ) {
        this.errorMessage =
          'Completa el título y las horas de la actividad.';
  
        return;
      }
  
      this.isSaving = true;
      this.errorMessage = '';
      this.successMessage = '';
  
      if (this.editingQuickActivityId) {
        this.updateQuickActivity();
        return;
      }
  
      this.quickActivityService
        .createQuickActivity(this.newQuickActivity)
        .subscribe({
          next: (quickActivity) => {
            this.quickActivities = [
                quickActivity,
                ...this.quickActivities,
              ];
  
            this.isSaving = false;
            this.showCreateForm = false;
            this.successMessage =
              'Actividad rápida creada correctamente.';
  
            this.resetForm();
  
            this.cdr.detectChanges();
          },
  
          error: (error: unknown) => {
            console.error(
              'ERROR CREANDO ACTIVIDAD RÁPIDA:',
              error,
            );
  
            this.isSaving = false;
            this.errorMessage =
              'No se pudo crear la actividad rápida.';
  
            this.cdr.detectChanges();
          },
        });
    }
  
    private updateQuickActivity(): void {
      const id = this.editingQuickActivityId;
  
      if (!id) {
        return;
      }
  
      this.quickActivityService
        .updateQuickActivity(id, this.newQuickActivity)
        .subscribe({
          next: (updatedActivity) => {
            this.quickActivities = this.quickActivities
              .map((activity) =>
                activity.id === updatedActivity.id
                  ? updatedActivity
                  : activity,
              )
              .sort((a, b) =>
                a.title.localeCompare(b.title, 'es', {
                  sensitivity: 'base',
                }),
              );
  
            this.isSaving = false;
            this.showCreateForm = false;
            this.editingQuickActivityId = null;
  
            this.successMessage =
              'Actividad rápida actualizada correctamente.';
  
            this.resetForm();
  
            this.cdr.detectChanges();
          },
  
          error: (error: unknown) => {
            console.error(
              'ERROR ACTUALIZANDO ACTIVIDAD RÁPIDA:',
              error,
            );
  
            this.isSaving = false;
            this.errorMessage =
              'No se pudo actualizar la actividad rápida.';
  
            this.cdr.detectChanges();
          },
        });
    }
  
    openPublishForm(activity: QuickActivity): void {
        this.successMessage = '';
        this.errorMessage = '';
      
        // Cerrar formulario de nueva actividad rápida
        this.showCreateForm = false;
        this.editingQuickActivityId = null;
      
        this.activityToPublish = activity;
      
        this.publishForm = {
          startDate: '',
          dueDate: '',
          startTime: activity.startTime,
          endTime: activity.endTime,
          maxParticipants: activity.maxParticipants,
          comments: activity.comments,
        };
      
        this.showPublishForm = true;
      }



        publishQuickActivity(): void {
            if (!this.activityToPublish) {
              return;
            }
          
            if (!this.publishForm.startDate || !this.publishForm.dueDate) {
              this.errorMessage =
                'Selecciona la fecha de inicio y la fecha de finalización.';
              return;
            }
          
            if (this.publishForm.dueDate < this.publishForm.startDate) {
              this.errorMessage =
                'La fecha de finalización no puede ser anterior a la fecha de inicio.';
              return;
            }
          
            this.isSaving = true;
            this.errorMessage = '';
            this.successMessage = '';
          
            this.quickActivityService
              .publishQuickActivity(this.activityToPublish.id, {
                startDate: this.publishForm.startDate,
                dueDate: this.publishForm.dueDate,
                startTime: this.publishForm.startTime,
                endTime: this.publishForm.endTime,
                maxParticipants: this.publishForm.maxParticipants,
                comments: this.publishForm.comments,
              })
              .subscribe({
                next: () => {
                  this.isSaving = false;
                  this.showPublishForm = false;
                  this.activityToPublish = null;
          
                  this.successMessage =
                    'Actividad publicada correctamente.';
          
                  this.cdr.detectChanges();
                },
                error: (error: unknown) => {
                  console.error(
                    'ERROR PUBLICANDO ACTIVIDAD:',
                    error,
                  );
          
                  this.isSaving = false;
                  this.errorMessage =
                    'No se pudo publicar la actividad.';
          
                  this.cdr.detectChanges();
                },
              });
          }
        openDeleteModal(activity: QuickActivity): void {
            this.activityToDelete = activity;
            this.showDeleteModal = true;
        }
      
        closeDeleteModal(): void {
            this.showDeleteModal = false;
            this.activityToDelete = null;
        }
    deleteQuickActivity(activity: QuickActivity): void {
      
        this.errorMessage = '';
        this.successMessage = '';
      
        this.quickActivityService.deleteQuickActivity(activity.id).subscribe({
          next: () => {
            this.quickActivities = this.quickActivities.filter(
              (item) => item.id !== activity.id,
            );
            this.closeDeleteModal();
            this.successMessage =
              'Actividad rápida eliminada correctamente.';
      
            this.cdr.detectChanges();
          },
      
          error: (error: unknown) => {
            console.error(
              'ERROR ELIMINANDO ACTIVIDAD RÁPIDA:',
              error,
            );
      
            this.errorMessage =
              'No se pudo eliminar la actividad rápida.';
      
            this.cdr.detectChanges();
          },
        });
      }
    private resetForm(): void {
      this.newQuickActivity = {
        title: '',
        description: '',
        type: 'optional',
        valueInHours: 0,
        startTime: '',
        endTime: '',
        maxParticipants: null,
        comments: '',
      };
    }
  }